// extracted by mini-css-extract-plugin
module.exports = {"offsiteLink":"ExternalLink_offsiteLink__NJ8iA"};